import React from "react";
import { IoIosCheckmarkCircle } from "react-icons/io";

const PlanCard = () => {
  return (
    <div style={{
      width: "100%",
      height: "100%",
      backgroundColor: "#fff",
      overflow: "hidden",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      borderRadius: "10px",
      boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
      transition: "0.3s",
    }}>
      {/* Plan Title */}
      <div>
        <div style={{
          backgroundColor: "#006699",
          color: "white",
          fontSize: "18px",
          fontWeight: "600",
          padding: "16px",
          textAlign: "center",
          borderTopLeftRadius: "10px",
          borderTopRightRadius: "10px"
        }}>
          Yearly Plan
        </div>

        {/* Features List */}
        <div style={{ padding: "20px" }}>
          {[
            "1 license you made up to 6 channel ",
            "Cloud Storage Up to 2 GB",
            "24/7 Support",
          ].map((feature, index) => (
            <div key={index} style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              marginBottom: "10px"
            }}>
              <IoIosCheckmarkCircle style={{ color: "#006699" }} size={22} />
              <p style={{
                color: "#374151",
                fontSize: "16px",
                margin: 0,
                fontFamily:"sans-serif"
              }}>{feature}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PlanCard;
